module.exports = __webpack_public_path__ + "assets/img/preparation.809060b0.svg";